<template>
  <layout-main-inner title="新建批次">
    <product-select-table ref="selectTable"
      v-show="step === 1" />
    <div v-show="step === 2">
      <product-info :loading="loading"
        :product="product" />

      <batch-form-dz ref="form"
        :loading="loading"
        :batch="batchInfo"
        :productId="product.productId"
        :tradeType="product.tradeType"
        :vendorId="+$route.query.vendorId"
        v-if="product.tagType === 1" />

      <batch-form-pm ref="form"
        :loading="loading"
        :batch="batchInfo"
        :productId="product.productId"
        :tradeType="product.tradeType"
        :tagType="product.tagType"
        :vendorId="+$route.query.vendorId"
        v-if="product.tagType !== 1 && $route.query.tagModel === '1' && product.codingType === 1 " />

      <batch-form-pm-ck ref="form"
        :loading="loading"
        :batch="batchInfo"
        :productId="product.productId"
        :tradeType="product.tradeType"
        :tagType="product.tagType"
        :vendorId="+$route.query.vendorId"
        v-if="product.tagType !== 1 && $route.query.tagModel === '1' && product.codingType === 2 " />

      <batch-form-tm ref="form"
        :loading="loading"
        :batch="batchInfo"
        :productId="product.productId"
        :tradeType="product.tradeType"
        :tagType="product.tagType"
        :vendorId="+$route.query.vendorId"
        v-if="product.tagType !== 1 && $route.query.tagModel === '2' && product.codingType === 1 " />

      <batch-form-tm-ck ref="form"
        :loading="loading"
        :batch="batchInfo"
        :productId="product.productId"
        :tradeType="product.tradeType"
        :tagType="product.tagType"
        :vendorId="+$route.query.vendorId"
        v-if="product.tagType !== 1 && $route.query.tagModel === '2' && product.codingType === 2 " />
    </div>
    <template slot="footer">
      <back-button ref="back" />
      <el-button type="primary"
        v-if="step === 1"
        @click="nextStep">下一步</el-button>
      <el-button type="primary"
        v-if="step === 2"
        @click="prevStep">上一步</el-button>
      <el-button type="primary"
        v-if="step === 2"
        @click="save">保存</el-button>
    </template>
  </layout-main-inner>
</template>

<script>
import ProductSelectTable from './busi/product-select-table.vue'
import ProductInfo from './busi/product-info.vue'
import batchFormDz from './busi/batch-form-dz.vue'
import batchFormPm from './busi/batch-form-pm.vue'
import batchFormTm from './busi/batch-form-tm.vue'
import batchFormPmCk from './busi/batch-form-pm-ck.vue'
import batchFormTmCk from './busi/batch-form-tm-ck.vue'
import '@/components/business/custom-form/index'
// import Utils from './busi/utils.js'
import TemplateFormat from '@/utils/templateFormat'
// import clonedeep from 'lodash.clonedeep'
export default {
  name: 'batch-create',
  components: { ProductSelectTable, ProductInfo, batchFormDz, batchFormPm, batchFormTm, batchFormPmCk, batchFormTmCk },
  props: {},
  data () {
    return {
      step: 1,
      loading: false,
      product: {},
      batchInfo: {
        baseFields: [],
        extraFields: []
      }
    }
  },
  methods: {
    prevStep () {
      this.$confirm('数据暂未保存，是否重新选择商品?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.step = 1
        })
    },
    nextStep () {
      let current = this.$refs.selectTable.getCurrent()
      console.log(current)
      if (!current) {
        this.$message.error('请先选择商品')
        return
      }
      this.product = current
      this.getcategorytemplate({
        classId: current.categoryId,
        tradeType: current.tradeType
      }, () => {
        this.step = 2
      })
    },
    getcategorytemplate (config, cb) {
      this.loading = true
      this.$store.dispatch('industry/getcategorytemplate', {
        payload: config,
        success: (res) => {
          this.loading = false
          let batchBaseTemplate = TemplateFormat.newTemplateFormat(res.data.batchBaseTemplate)
          let batchExtraTemplate = TemplateFormat.newTemplateFormat(res.data.batchExtraTemplate || [])
          this.batchInfo.baseFields = batchBaseTemplate
          this.batchInfo.extraFields = batchExtraTemplate
          cb && cb()
        },
        fail: () => {
          this.loading = false
          this.batchInfo.baseFields = []
          this.batchInfo.extraFields = []
        }
      })
    },
    save () {
      this.$refs.form.submit((res) => {
        this.loading = true
        let postdata = {
          vendorId: this.$route.query.vendorId,
          productId: this.product.productId,
          tagModel: this.$route.query.tagModel,
          codingType: this.product.codingType,
          isContinous: 1,
          ...res
        }
        this.$store.dispatch('batch/addbatch', {
          payload: postdata,
          success: (res) => {
            this.loading = false
            this.$refs.back.back()
          },
          fail: () => {
            this.loading = false
          }
        })
      })
    }
  },
  created () { },
  mounted () { }
}
</script>
<style lang="stylus"></style>
